import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {DeferredData} from '../types/commits-types'
import {useEffect, useState} from 'react'
import {baseEmptyStateLoading, baseEmptyStateNotLoading} from '../contexts/DeferredCommitDataContext'

export function useLoadDeferredCommitData(url: string): DeferredData {
  const [state, setState] = useState<DeferredData>(baseEmptyStateLoading)

  useEffect(() => {
    if (!url) return

    let cancelled = false
    const update = async () => {
      setState(baseEmptyStateLoading)
      const response = await verifiedFetchJSON(url)

      if (cancelled) {
        return
      }

      try {
        if (response.ok) {
          const data = await response.json()
          data.loading = false
          if (data) {
            setState(data)
          }
        } else {
          setState(baseEmptyStateNotLoading)
        }
      } catch (e) {
        setState(baseEmptyStateNotLoading)
      }
    }

    update()

    return function cancel() {
      cancelled = true
    }
  }, [url])

  return state
}
